import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody49.css';

import clientimg from '../images/case-study-client49.webp'
import outcome from '../images/outcome49.webp'

import sm1 from '../images/cs49so1.webp'
import sm2 from '../images/cs49so2.webp'
import sm3 from '../images/cs49so3.webp'
import sm4 from '../images/cs49so4.webp'
import sm5 from '../images/cs49so5.webp'


const Casestudybody49 = () => {

    return (
        <>
        <section className='casestudybody49-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client is a PE firm focused on providing equity-funded capital to scale established businesses. It partners with experienced operators in fragmented industries to drive growth and long-term value creation</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client required support in preparing Business Due Diligence (BDD) data cuts for potential add-on targets for one of its platform companies. This involved evaluating companies across a range of financial and operational KPIs, including but not limited to revenue composition, customer churn, and balance sheet analysis</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody49-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Data Structuring:</h4>
                          <p>Ingested raw financial and operational datasets from target companies, resolving <span style={{color:"#03A393",fontWeight:700}}> missing data points, aligning nomenclature,</span> and creating a <span style={{color:"#03A393",fontWeight:700}}> consistent master structure</span> to <span style={{color:"#03A393",fontWeight:700}}> ensure comparability across targets</span></p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Financial & Operational Metrics Evaluation:</h4>
                          <p>Conducted detailed analysis across <span style={{color:"#03A393",fontWeight:700}}> balance sheet strength, AR/AP cycles, revenue sustainability, customer dynamics, workforce structure,</span> and <span style={{color:"#03A393",fontWeight:700}}>   EBITDA adjustments</span> to build a comprehensive understanding of each target's <span style={{color:"#03A393",fontWeight:700}}> business fundamentals</span> and investment viability</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Variance & Trend Identification:</h4>
                          <p>Applied <span style={{color:"#03A393",fontWeight:700}}> historical and peer-comparative analysis to</span> detect <span style={{color:"#03A393",fontWeight:700}}> anomalies, emerging trends,</span> and red flags such as <span style={{color:"#03A393",fontWeight:700}}> revenue instability, customer concentration risks,</span> and <span style={{color:"#03A393",fontWeight:700}}> margin compression</span></p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Risk Flagging Framework:</h4>
                          <p>Developed a structured flagging system to highlight potential risks such as <span style={{color:"#03A393",fontWeight:700}}> revenue instability, customer dependency,</span> and <span style={{color:"#03A393",fontWeight:700}}> margin compression</span>, enabling prioritization based on <span style={{color:"#03A393",fontWeight:700}}> risk-adjusted attractiveness</span></p>
                        </div>
                      </div>

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Deal Summary Preparation:</h4>
                          <p>Synthesized findings into concise, insight-driven deal summaries presenting a clear snapshot of each target's <span style={{color:"#03A393",fontWeight:700}}> financial health</span> and <span style={{color:"#03A393",fontWeight:700}}> operational efficiency</span>, supporting <span style={{color:"#03A393",fontWeight:700}}> rapid evaluation</span> and <span style={{color:"#03A393",fontWeight:700}}> decision-making</span></p>
                        </div>
                      </div>     

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                      </div>  
                      <div className='sample-output1 mt-3'>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                        <img src={sm5} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody49-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client was equipped with a BDD data cut and Deal overview framework that supported faster, more accurate investment screening. By resolving & flagging data inconsistencies and presenting insight-driven outputs, the process improved decision-making speed and reduced turnaround time for “go/no-go” calls in the deal pipeline</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody49
